module.exports = __webpack_public_path__ + "../resources/img/japan.c1724386.png";